// extracted by css-extract-rspack-plugin
export default {"text":"mzE20mxZlQ2bjnO_"};